import { useConfigStore } from '@/stores';
import './global.css';
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import nextSvg from '@/assets/images/next.svg';
import prevSvg from '@/assets/images/prev.svg';
import { generateFloorName } from '@/utils/floor-guide';
import { useTickSoundInteraction } from '@/hooks';
import { JAMSIL_MAP_IDS } from '@/constants/app';

interface AllFloorsGuideProps {
    onSelectFloor?: (floorName: string, floorId?: string, buildingId?: string) => void;
}

const htmlTemplate = `<div class="all-floors-scroll-wrapper no-scrollbar" style="width:100%;overflow-x:auto;box-sizing:border-box;">
    <style>
        .no-scrollbar {
            overflow: auto;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE 10+ */
        }

        /* Ẩn scrollbar trên Chrome, Safari */
        .no-scrollbar::-webkit-scrollbar {
            display: none;
            width: 0px;
            height: 0px;
        }

        .left-part {
            width: 30vw;
            height: 100%;
            display: block;
            opacity: 0;
        }

        .right-part {
            width: 50vw;
            height: 100%;
            display: block;
            opacity: 0;
        }

        .no-border-bottom {
            border-bottom: none !important;
        }

        .floor-guide-floor--bg-white {
            background-color: var(--color-bg-white) !important;
        }
        .font-small {
            font-size: 1.3vh;
        }
    </style>
    <div class="all-floors-inner floor-guide-drag-container"
        style="width:104.3333333334vw;display:flex;box-sizing:border-box;">
        <div class="left-part">1</div>
        <div class="floor-guide-floors" id="id-0375">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">캐슬플라자</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-u7rsiy7lfjvq4591" data-x="10896" data-y="1752">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">식당가</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-1hv2q23iykrhs4641" data-x="10896" data-y="1752">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">여성의류ㅣF&amp;Bㅣ기타</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-ts56rc9vkjec4705" data-x="10896" data-y="1752">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">롯데프리미엄푸드마켓ㅣ교보문고ㅣ핫트랙스ㅣF&amp;B</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="10896" data-y="1752">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
        </div>
        <div class="floor-guide-floors" id="id-0500">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">본관</div>
            </div>
            <div class="floor-guide-floor floor-guide-no-click" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english font-small">117F<br/>-123F</span>
                <span class="floor-guide-floor-desc">SEOUL SKY (전망대)</span>
            </div>
            <div class="floor-guide-floor floor-guide-no-click" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english font-small">76F<br/>-101F</span>
                <span class="floor-guide-floor-desc">시그니엘 서울</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">31F</span>
                <span class="floor-guide-floor-desc">SKY31 컨벤션ㅣ마키노차야블랙31</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">30F</span>
                <span class="floor-guide-floor-desc">워크플렉스 롯데월드타워</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-1hrj94p1zs2m14355" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">12F</span>
                <span class="floor-guide-floor-desc">은행ㅣ증권</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-sl15eempzdr84340" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">11F</span>
                <span class="floor-guide-floor-desc">안과ㅣ치과ㅣ피부과ㅣ카페</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-1hrj94p1zs2m14355" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-rl042p1d1v7b4376" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-vbmxfa3a2a7l4402" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-rhiu9pjwtwkz4423" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right floor-guide-no-click" data-id="FL-t4vqscsfs7ci4441" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">7F</span>
                <span class="floor-guide-floor-desc">뮤지엄</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-t4nv4gumihcx4511" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-t4nv4gumihcx4511" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-qdt9ayjtve494549" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-u7rsiy7lfjvq4591" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">로비</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-1hv2q23iykrhs4641" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">명품잡화ㅣ화장품ㅣ시계&amp;보석</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-ts56rc9vkjec4705" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">식품</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-qhqlf2653bdy4781" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english">B2-B4</span>
                <span class="floor-guide-floor-desc">Parking Lot</span>
            </div>
        </div>
        <div class="floor-guide-floors" id="id-0409">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">월드몰</div>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-t4vqscsfs7ci4441" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">식당가ㅣ뷰티&amp;스파ㅣ시네마</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-qxqkodqsjub84475" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">식당가ㅣ카페ㅣ롯데시네마</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-t4nv4gumihcx4511" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">키즈ㅣ서점ㅣ캐주얼ㅣ씨푸드 레스토랑</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qdt9ayjtve494549" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">스포츠·레저ㅣ패밀리레스토랑ㅣ하이마트</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-u7rsiy7lfjvq4591" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">SPAㅣ여성패션ㅣ카페ㅣ악세사리</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-1hv2q23iykrhs4641" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">SPAㅣ화장품ㅣ여성패션ㅣ베이커리·카페</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-ts56rc9vkjec4705" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">패션ㅣ푸드코트ㅣ아쿠아리움</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
        </div>
        <div class="floor-guide-floors" id="id-0348">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">에비뉴엘</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4vqscsfs7ci4441" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">프리미엄 F&amp;B ㅣ와인</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qxqkodqsjub84475" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">여성 컨템포러리</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4nv4gumihcx4511" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">럭셔리 맨즈</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qdt9ayjtve494549" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-u7rsiy7lfjvq4591" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">워치&amp;주얼리ㅣ럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-1hv2q23iykrhs4641" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">럭셔리 부티크</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-ts56rc9vkjec4705" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">화장품</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
        </div>
        <div class="floor-guide-floors" id="id-0002">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">에비뉴엘</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4vqscsfs7ci4441" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">12F</span>
                <span class="floor-guide-floor-desc">프리미엄 F&amp;B ㅣ와인</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qxqkodqsjub84475" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">11F</span>
                <span class="floor-guide-floor-desc">여성 컨템포러리</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4nv4gumihcx4511" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">10F</span>
                <span class="floor-guide-floor-desc">럭셔리 맨즈</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qdt9ayjtve494549" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">9F</span>
                <span class="floor-guide-floor-desc">럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-u7rsiy7lfjvq4591" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">8F</span>
                <span class="floor-guide-floor-desc">워치&amp;주얼리ㅣ럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1hv2q23iykrhs4641" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">7F</span>
                <span class="floor-guide-floor-desc">럭셔리 부티크</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4vqscsfs7ci4441" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">프리미엄 F&amp;B ㅣ와인</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qxqkodqsjub84475" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">여성 컨템포러리</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4nv4gumihcx4511" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">럭셔리 맨즈</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qdt9ayjtve494549" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-u7rsiy7lfjvq4591" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">워치&amp;주얼리ㅣ럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1hv2q23iykrhs4641" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">럭셔리 부티크</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-ts56rc9vkjec4705" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">화장품</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-qhqlf2653bdy4781" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english">B2-B4</span>
                <span class="floor-guide-floor-desc">Parking Lot</span>
            </div>
        </div>
        <div class="right-part">2</div>
    </div>
</div>`;

const FLOORTEXT = {
    '7F': {
        'ko': '뮤지엄',
        'en': 'Museum',
        'zh-CN': '博物馆',
        'zh-TW': '博物館',
        'ja': 'ミュージアム'
    },
    '30F': {
        'ko': '워크플렉스 롯데월드타워',
        'en': 'Workflex Lotte World Tower',
        'zh-CN': 'Workflex Lotte World Tower',
        'zh-TW': 'Workflex Lotte World Tower',
        'ja': 'Workflex Lotte World Tower'
    },
    '76F': {
        'ko': '시그니엘 서울',
        'en': 'Signiel Seoul',
        'zh-CN': 'Signiel Seoul',
        'zh-TW': 'Signiel Seoul',
        'ja': 'シグニエルソウル'
    },
    '117F': {
        'ko': 'SEOUL SKY (전망대)',
        'en': 'Observatory',
        'zh-CN': '觀景臺',
        'zh-TW': '观景台',
        'ja': '展望台'
    },
    '2F': {
        'ko': '로비',
        'en': 'Lobby',
        'zh-CN': '大廳',
        'zh-TW': '大厅',
        'ja': 'ロビー'
    }

} as const;

export const AllFloorsGuide = ({ onSelectFloor }: AllFloorsGuideProps) => {
    const { t, i18n } = useTranslation();
    const [staticHtml, setStaticHtml] = useState<string>('');
    const buildings = useConfigStore((state) => state.config?.server?.store?.buildings);
    const currentBuilding = useConfigStore((state) => state.config?.server?.building);
    const html = useConfigStore((state) => state.config?.server?.store?.fullMapHtml);
    const orientation = document.body.dataset.orientation;
    const nodeRef = useRef<HTMLDivElement | null>(null);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const { playTick } = useTickSoundInteraction();
    const mapId = useConfigStore((state) => state?.config?.server?.store?.studioMapId) || '';
    const isJamsil = JAMSIL_MAP_IDS.includes(mapId);

    // Click handler for regular floors
    const handleFloorClick = (event: Event) => {
        const target = event.target as HTMLElement;
        const floorEl = target.closest('.floor-guide-floor') as HTMLElement;
        const floorNoClick = target.closest('.floor-guide-no-click') as HTMLElement;

        if (!floorEl || floorNoClick) return;

        const buildingEl = floorEl.closest('.floor-guide-floors') as HTMLElement;
        if (!buildingEl) return;

        const storeCode = buildingEl.getAttribute('id')?.replace('id-', '') || '';
        const building = buildings?.find((b) => b.storeCode === storeCode);
        const buildingId = building?.studioBuildingId || '';

        const floorNameEl = floorEl.querySelector('.floor-guide-floor-name');

        if (onSelectFloor) {
            if (!isJamsil) {
                onSelectFloor(floorNameEl?.textContent || '');
            } else {
                onSelectFloor(floorNameEl?.textContent || '', floorEl?.getAttribute('data-floor-id') || '', buildingId);
            }
        }
    };

    // Click handler for gray floors
    const handleGrayFloorClick = (event: Event) => {
        const target = event.target as HTMLElement;
        const floorEl = target.closest('.floor-guide-floor--gray') as HTMLElement;
        if (!floorEl) return;

        const buildingEl = floorEl.closest('.floor-guide-floors') as HTMLElement;
        if (!buildingEl) return;
        const storeCode = buildingEl.getAttribute('id')?.replace('id-', '') || '';
        const building = buildings?.find((b) => b.storeCode === storeCode);
        const buildingId = building?.studioBuildingId || '';

        if (onSelectFloor) {
            if (!isJamsil) {
                onSelectFloor(floorEl.textContent || '');
            } else {
                onSelectFloor(floorEl.textContent || '', floorEl.getAttribute('data-floor-id') || '', buildingId);
            }
        }
    };

    useEffect(() => {
        const container = nodeRef.current;
        if (!container || !currentBuilding) return;

        // Đổ static HTML gốc vào
        container.innerHTML = !isJamsil ? (html || '') : htmlTemplate;


        // Duyệt qua từng building trong dữ liệu JSON
        buildings?.forEach((building) => {

            const buildingEl = container.querySelector(
                !isJamsil ? `#${building?.buildingType}` : `#id-${building?.storeCode}`
            );

            if (!buildingEl) return; // không có trong DOM tĩnh

            const buidlingIndex = String(currentBuilding?.buildingType) === buildingEl.getAttribute('id') ? 1 : 2;

            const tabIndexDefault = orientation == 'vertical' ? 1 : 10;

            const mallNameEl = buildingEl.querySelector(".floor-guide-mall-name-tts");
            if (mallNameEl) {
                const buidlingName = building.name?.[i18n.language] || building.name?.ko || "";
                mallNameEl.textContent = buidlingName;
                mallNameEl.setAttribute('aria-label', buidlingName);
                buildingEl.setAttribute('data-region-nav', 'true');
                buildingEl.setAttribute('data-region-order', `${tabIndexDefault + buidlingIndex}`);
                mallNameEl.setAttribute('tabindex', `${tabIndexDefault + buidlingIndex}`);
                mallNameEl.classList.add('focus-border-floor');
                mallNameEl.setAttribute('data-interactive', 'true');
            }

            building.floors.forEach((floor) => {
                const floorEl = Array.from(
                    buildingEl.querySelectorAll(".floor-guide-floor")
                ).find(
                    (el) =>
                        el.querySelector(".floor-guide-floor-name")?.textContent?.trim() ===
                        floor.name.ko
                );

                if (floorEl) {
                    // floorEl.setAttribute('tabindex', tabindex.toString());
                    floorEl.setAttribute('data-interactive', 'true');
                    floorEl.classList.add('focus-border-floor');
                    floorEl.setAttribute('data-role', t('common.data_role.button'));
                    floorEl.setAttribute('tabindex', `${tabIndexDefault + buidlingIndex}`);
                    // Cập nhật mô tả (theo đúng ngôn ngữ)
                    const descEl = floorEl.querySelector(".floor-guide-floor-desc");
                    floorEl.setAttribute('data-floor-id', floor.floorCode);
                    floorEl.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName(floor.name.ko ?? ''), }) || ''}, ${descEl?.textContent}`);

                    if (descEl && floor.lotteDescription) {
                        const floorDesc = floor.lotteDescription[i18n.language];
                        descEl.textContent = floorDesc;
                        floorEl.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName(floor.name.ko ?? ''), }) || ''}, ${floorDesc}`);
                    } else if (i18n.language !== 'ko' && building.storeCode === '0500' && isJamsil) {
                        switch (floor.name.ko) {
                            case '31F':
                                const text = "SKY 31 Convention";
                                descEl!.textContent = text;
                                floorEl.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName(floor.name.ko ?? ''), }) || ''}, ${text}`);
                                break;
                            case '12F':
                                const text12 = "Finance Center";
                                descEl!.textContent = text12;
                                floorEl.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName(floor.name.ko ?? ''), }) || ''}, ${text12}`);
                                break;
                            case '11F':
                                const text11 = "Medical Center";
                                descEl!.textContent = text11;
                                floorEl.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName(floor.name.ko ?? ''), }) || ''}, ${text11}`);
                                break;
                            case '7F':
                                const text7 = FLOORTEXT[floor.name.ko][i18n.language as keyof typeof FLOORTEXT['7F']] || FLOORTEXT[floor.name.ko]['en'];
                                descEl!.textContent = text7;
                                floorEl.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName(floor.name.ko ?? ''), }) || ''}, ${text7}`);
                                break;
                        }
                    }
                } else {
                    const floorElGray = buildingEl.querySelector(".floor-guide-floor--gray")
                    if (!floorElGray) return;
                    floorElGray?.setAttribute('data-interactive', 'true');
                    floorElGray.setAttribute('data-role', t('common.data_role.button'));
                    floorElGray?.classList.add('focus-border-floor');
                    floorElGray?.setAttribute('tabindex', `${tabIndexDefault + buidlingIndex}`);
                    const descEl = floorElGray?.querySelector(".floor-guide-floor-desc");
                    floorElGray?.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName('B2-B7'), }) || ''}, ${descEl?.textContent}`);
                }
            });

            if (building.storeCode === '0500' && isJamsil) {
                const floorEl = Array.from(
                    buildingEl.querySelectorAll(".floor-guide-floor")
                ).find(
                    (el) =>
                        el.querySelector(".floor-guide-floor-name")?.textContent?.trim() === '2F'
                );

                const descEl = floorEl?.querySelector(".floor-guide-floor-desc");
                const text2 = FLOORTEXT['2F'][i18n.language as keyof typeof FLOORTEXT['2F']] || FLOORTEXT['2F']['en'];
                if (descEl) {
                    descEl.textContent = text2;
                }
                floorEl?.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName('2F'), }) || ''}, ${text2}`);

                const floorEl2 = Array.from(
                    buildingEl.querySelectorAll(".floor-guide-floor")
                ).find(
                    (el) =>
                        el.querySelector(".floor-guide-floor-name")?.textContent?.trim().includes('76F')
                );

                const descEl2 = floorEl2?.querySelector(".floor-guide-floor-desc");
                const text3 = FLOORTEXT['76F'][i18n.language as keyof typeof FLOORTEXT['76F']] || FLOORTEXT['76F']['en'];
                if (descEl2) {
                    descEl2.textContent = text3;
                }
                floorEl2?.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName('76F - 101F'), }) || ''}, ${text3}`);

                const floorEl3 = Array.from(
                    buildingEl.querySelectorAll(".floor-guide-floor")
                ).find(
                    (el) =>
                        el.querySelector(".floor-guide-floor-name")?.textContent?.trim().includes('117F')
                );

                const descEl3 = floorEl3?.querySelector(".floor-guide-floor-desc");
                const text4 = FLOORTEXT['117F'][i18n.language as keyof typeof FLOORTEXT['117F']] || FLOORTEXT['117F']['en'];
                if (descEl3) {
                    descEl3.textContent = text4;
                }
                floorEl3?.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName('117F - 123F'), }) || ''}, ${text4}`);

                const floorEl4 = Array.from(
                    buildingEl.querySelectorAll(".floor-guide-floor")
                ).find(
                    (el) =>
                        el.querySelector(".floor-guide-floor-name")?.textContent?.trim().includes('30F')
                );

                const descEl4 = floorEl4?.querySelector(".floor-guide-floor-desc");
                const text5 = FLOORTEXT['30F'][i18n.language as keyof typeof FLOORTEXT['30F']] || FLOORTEXT['30F']['en'];
                if (descEl4) {
                    descEl4.textContent = text5;
                }
                floorEl3?.setAttribute('aria-label', `${t('floor_guide.text_to_speech.floor', { floorName: generateFloorName('30F'), }) || ''}, ${text5}`);
            }
        });

        setStaticHtml(container.innerHTML);

    }, [buildings, i18n, html, currentBuilding]);

    useEffect(() => {
        setTimeout(() => {
            const container = nodeRef.current;
            if (!container || !currentBuilding) return;

            const building = buildings?.find((b) => b.id === currentBuilding.id);
            const buildingEl = container.querySelector(
                !isJamsil ? `#${currentBuilding?.buildingType}` : `#id-${building?.storeCode}`
            );

            console.log('AllFloorsGuide scrollIntoView', buildingEl);

            buildingEl?.scrollIntoView({
                behavior: "smooth",   // cuộn mượt
                block: "center",      // căn giữa theo chiều dọc
                inline: "center"      // căn giữa theo chiều ngang (nếu phần tử nằm ngang)
            });
            if (orientation == 'vertical') {
                const b = document.querySelector('.all-floor-guide-title') as HTMLElement;
                b.focus();
            } else {
                const a = buildingEl?.querySelector('.floor-guide-mall-name-tts') as HTMLElement;
                console.log('AllFloorsGuide focus', a);
                a.focus();
            }
        }, 300);
    }, [staticHtml, currentBuilding])

    // Add click event listeners after HTML is rendered
    useEffect(() => {
        const container = nodeRef.current;
        if (!container) return;

        // Add click listeners to all floor elements
        const floorElements = container.querySelectorAll('.floor-guide-floor:not(.floor-guide-floor--gray)');

        const handleKeyDown = (e: Event) => {
            const event = e as KeyboardEvent;
            if (event.key === 'Enter') {
                playTick();
                handleFloorClick(event);
            }
        };

        floorElements.forEach((floorEl) => {
            // Remove existing listeners to avoid duplicates
            floorEl.removeEventListener('click', handleFloorClick);
            floorEl.removeEventListener('keydown', handleKeyDown);

            // Add new listener
            floorEl.addEventListener('click', handleFloorClick);
            floorEl.addEventListener('keydown', handleKeyDown);

        });

        // Add click listeners to gray floor elements
        const grayFloorElements = container.querySelectorAll('.floor-guide-floor--gray');
        grayFloorElements.forEach((floorEl) => {
            // floorEl.removeEventListener('click', handleGrayFloorClick);
            // floorEl.removeEventListener('keydown', handleKeyDown);

            // floorEl.addEventListener('click', handleGrayFloorClick);
            // floorEl.addEventListener('keydown', handleKeyDown);


        });

        // Cleanup function
        return () => {
            floorElements.forEach(floorEl => {
                floorEl.removeEventListener('click', handleFloorClick);
                floorEl.removeEventListener('keydown', handleKeyDown)
            });
            grayFloorElements.forEach(floorEl => {
                floorEl.removeEventListener('click', handleGrayFloorClick);
                floorEl.removeEventListener('keydown', handleKeyDown)
            });
        };
    }, [staticHtml, onSelectFloor]);

    return (
        <div className="floor-guide-container all-floors-scroll-wrapper no-scrollbar" ref={containerRef}>
            {buildings && buildings?.length > 1 &&
                <>
                    <img
                        className="floor-guide-arrow floor-guide-arrow--left"
                        src={prevSvg}
                        alt="Previous"
                        style={{ pointerEvents: 'none' }}
                    />
                    <img
                        className="floor-guide-arrow floor-guide-arrow--right"
                        src={nextSvg}
                        alt="Next"
                        style={{ pointerEvents: 'none' }}
                    />
                </>}
            <div
                ref={nodeRef}

                className={`floor-guide-drag-content`}
                dangerouslySetInnerHTML={{ __html: staticHtml }}
            />
        </div>
    );
};
